module.exports = __webpack_public_path__ + "img/logo-header.29762e8f.svg";